module.exports = __webpack_public_path__ + "static/media/ePosterRental.dcf2bea8.jpg";